(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('[data-slider]');
  const slides = slider.querySelectorAll('.slider-slide');
  const prevBtn = slider.querySelector('[data-prev]');
  const nextBtn = slider.querySelector('[data-next]');
  let index = 0;

  // Autoplay settings
  let autoplay = true;   // set false to disable
  let autoplayDelay = 5000; // 5s
  let autoplayInterval;

  function updateSlider() {
    slides.forEach((slide, i) => {
      slide.classList.remove('active');
      if (i === index) slide.classList.add('active');
    });
  }

  function showNext() {
    index = (index + 1) % slides.length;
    updateSlider();
  }

  function showPrev() {
    index = (index - 1 + slides.length) % slides.length;
    updateSlider();
  }

  // Autoplay functions
  function startAutoplay() {
    if (autoplay) {
      autoplayInterval = setInterval(showNext, autoplayDelay);
    }
  }

  function resetAutoplay() {
    if (autoplay) {
      clearInterval(autoplayInterval);
      startAutoplay();
    }
  }

  // Button Events
  prevBtn.addEventListener('click', () => {
    showPrev();
    resetAutoplay();
  });

  nextBtn.addEventListener('click', () => {
    showNext();
    resetAutoplay();
  });

  // Touch Support
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    const threshold = 50;
    if (touchEndX < touchStartX - threshold) {
      showNext();
      resetAutoplay();
    }
    if (touchEndX > touchStartX + threshold) {
      showPrev();
      resetAutoplay();
    }
  }

  updateSlider();
  startAutoplay();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-banner-background"] && !Shopify.designMode) return;
  try {
    
function setImageBannerBackground() {
  const banner = document.querySelector('.image-banner');
  if (!banner) return;
  const desktopBg = banner.dataset.desktop;
  const mobileBg = banner.dataset.mobile;
  const isMobile = window.innerWidth <= 768;
  banner.style.backgroundImage = `url(${isMobile ? mobileBg : desktopBg})`;
}

function revealBannerContent() {
  const content = document.querySelector('.image-banner__content');
  if (!content) return;
  setTimeout(() => {
    content.classList.add('visible');
  }, 300);
}

document.addEventListener('DOMContentLoaded', () => {
  setImageBannerBackground();
  revealBannerContent();
});
window.addEventListener('resize', setImageBannerBackground);

  } catch(e) { console.error(e); }
})();
})();
